var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    'teatree-node-item-name',
    { 'teatree-node-item-name-padded': this.haveLeftPadding } ],on:{"click":function($event){return _vm.handleNodeLeftClick(_vm.node, $event)},"contextmenu":function($event){$event.preventDefault();return _vm.handleNodeRightClick(_vm.node, $event)}}},[_vm._v(" "+_vm._s(_vm.node.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }